export default __webpack_public_path__ + "static/media/46.8841a029.jpg";